import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lodash from 'lodash'
import moment from 'moment'
import VueClipboard from 'vue-clipboard2'

import './permission'
import '@/assets/styles/wang_editor_text.less'
import '@/core/lazy_use' // 按需加载
import './utils/filter'
import { setFavicon } from '@/utils/dom_util'
import socket from '@/utils/socket'
import '@/assets/styles/global.less'
import Print from '@/utils/print'
Vue.use(VueClipboard)
Vue.use(Print)

Vue.prototype.$lodash = lodash
Vue.prototype.$moment = moment
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$pullNotifications = lodash.throttle(function() {
  return store.dispatch('PullNotifications')
}, 2000)
Vue.config.productionTip = false
Vue.prototype.$socket = socket
// 设置网站图标
setFavicon(window.customConfig.faviconUrl)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
